import create from './create';
import update from './update';
import auth from './auth';
import facebookAuth from './facebook-auth';
import passwordRecovery from './password-recovery';

export default {
  namespaced: true,
  modules: {
    create,
    update,
    auth,
    passwordRecovery,
    facebookAuth
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js